import api from '../../utils/services/api';
import { detailsPixLimitRequestActionLoading } from '../ducks/pixLimitRequest';

import {
  pixRefundActionLoading,
  pixRefundActionSuccess,
  pixRefundActionError,
  typeParticipantsSuccess,
  typeParticipantsError,
  typeStatusRefundError,
  typeStatusRefundSuccess,
  detailsPixRefundActionSuccess,
  detailsPixRefundActionLoading,
  createRefundLoading,
  createRefundSuccess,
} from '../ducks/pixRefund';
import { showAlert } from '../ducks/sweetAlert';

export const pixRefundFetchActions = (filter = { LIMITE: 100, PAGINA: 1 }) => {
  return async (dispatch) => {
    dispatch(pixRefundActionLoading());

    try {
      const response = await api.get(`admin/pix/listar/devolucoes`, { params: filter });
      dispatch(pixRefundActionSuccess(response));
    } catch (error) {
      dispatch(pixRefundActionError(error?.response?.data));
    }
  };
};

export const pixRefundTypeParticipantsFetchActions = () => {
  return async (dispatch) => {
    dispatch(pixRefundActionLoading());

    try {
      const response = await api.get(`admin/pix/papel/participante`);
      dispatch(typeParticipantsSuccess(response));
    } catch (error) {
      dispatch(typeParticipantsError(error?.response?.data));
    }
  };
};

export const pixRefundTypeStatusFetchActions = () => {
  return async (dispatch) => {
    dispatch(pixRefundActionLoading());

    try {
      const response = await api.get(`admin/pix/status/devolucao`);
      dispatch(typeStatusRefundSuccess(response));
    } catch (error) {
      dispatch(typeStatusRefundError(error?.response?.data));
    }
  };
};

export const pixRefundDetailsFetchActions = (transactionId) => {
  return async (dispatch) => {
    dispatch(detailsPixRefundActionLoading());

    try {
      const response = await api.get(`admin/pix/consultar/devolucao`, { params: { ID_SOLICITACAO: transactionId } });

      dispatch(detailsPixRefundActionSuccess(response));
    } catch (error) {
      dispatch(pixRefundActionError(error?.response?.data));
    }
  };
};

export const pixRefundCloseActions = (params, close) => {
  return async (dispatch) => {
    dispatch(detailsPixLimitRequestActionLoading());

    try {
      const response = await api.post(`/admin/pix/cancelar/devolucao`, { ...params });

      dispatch(detailsPixRefundActionSuccess(response));
      close();
    } catch (error) {
      dispatch(pixRefundActionError(error?.response?.data));
    }
  };
}

export const pixRefundCancelActions = (params, close) => {
  return async (dispatch) => {
    dispatch(detailsPixLimitRequestActionLoading());

    try {
      const response = await api.post(`/admin/pix/cancelar/devolucao`, { ...params });

      dispatch(detailsPixRefundActionSuccess(response));
      close();
    } catch (error) {
      dispatch(pixRefundActionError(error?.response?.data));
    }
  };
}

export const pixRefundCreateAction = (params, close) => {
  return async (dispatch) => {
    dispatch(createRefundLoading());

    const handleClose = () => {
      dispatch(pixRefundFetchActions());
      close();
    }

    try {
      const response = await api.post(`/admin/pix/solicitar/devolucao`, { ...params });

      dispatch(createRefundSuccess(response));

      dispatch(
        showAlert({
          title: 'Sucesso',
          text: response?.data?.mensagem,
          icon: 'success',
          func: handleClose
        }),
      );

    } catch (error) {
      dispatch(showAlert({
        title: 'Ops...',
        text: error?.response?.data?.mensagem,
        icon: 'error',
      }));
    }
  };
}
